// Function to initialize mobile footer accordion
function initMobileFooterAccordion() {
  // Only run on mobile
  if (window.innerWidth <= 1024) {
    const footerSections = document.querySelectorAll('.footer-main .links-footer, .footer-main .social-media-footer');
    
    footerSections.forEach(function(section) {
      const header = section.querySelector('.footer-header');
      
      if (header && !header.hasAttribute('data-accordion-initialized')) {
        // Mark as initialized to prevent duplicate listeners
        header.setAttribute('data-accordion-initialized', 'true');
        
        header.addEventListener('click', function() {
          section.classList.toggle('active');
        });
      }
    });
  } else {
    // Desktop view - remove active classes and reset
    const footerSections = document.querySelectorAll('.footer-main .links-footer, .footer-main .social-media-footer');
    footerSections.forEach(function(section) {
      section.classList.remove('active');
      const header = section.querySelector('.footer-header');
      if (header) {
        header.removeAttribute('data-accordion-initialized');
      }
    });
  }
}

// Initialize on page load
document.addEventListener('DOMContentLoaded', function() {
  initMobileFooterAccordion();
});

// Re-initialize on window resize with debounce
let resizeTimer;
window.addEventListener('resize', function() {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(function() {
    initMobileFooterAccordion();
  }, 250); // Wait 250ms after resize stops
});

// Mutation observer to watch for DOM changes (useful for AJAX-loaded content)
const observer = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    if (mutation.addedNodes.length) {
      initMobileFooterAccordion();
    }
  });
});

// Start observing the document body for changes
if (document.body) {
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}

// Hide local pickup for non-BOPIS
document.addEventListener("DOMContentLoaded", function () {
    const hideUnavailablePickup = () => {
        // Select all elements with the class `store-availability-information`
        const availabilityElements = document.querySelectorAll("div.store-availability-information");

        availabilityElements.forEach(availability => {
            // Find the title element
            const titleElement = availability.querySelector("p.store-availability-information__title");

            // Check if the title contains "Pickup currently unavailable"
            if (titleElement && titleElement.textContent.trim().includes("Pickup currently unavailable")) {
                // Hide the entire parent container or the specific wrapper
                availability.style.display = "none"; // Alternatively, target a child element if needed
            }
        });
    };

    // Run the function initially to hide elements already in the DOM
    hideUnavailablePickup();

    // Set up MutationObserver to monitor dynamic changes
    const observer = new MutationObserver(() => {
        hideUnavailablePickup(); // Re-run the function on DOM changes
    });

    // Observe changes to the body or a narrower container
    observer.observe(document.body, {
        childList: true,  // Watch for added/removed child nodes
        subtree: true,    // Include changes in the entire subtree
    });
});

// Social Share Section
document.addEventListener('click', function (e) {
  const btn = e.target.closest('.vs-share__copy-btn');
  if (!btn) return;

  const url = btn.getAttribute('data-copy-url');
  const feedback = btn.parentElement.querySelector('.vs-share__copy-feedback');

  navigator.clipboard.writeText(url).then(function () {
    if (feedback) {
      feedback.textContent = 'Copied!';
      feedback.classList.add('is-visible');
      setTimeout(function () {
        feedback.classList.remove('is-visible');
      }, 2000);
    }
  });
});

// Blog - Table of Contents
document.addEventListener('DOMContentLoaded', function () {
  const configEl = document.querySelector('[data-toc-config]');
  const intro = document.querySelector('.vs-blog-article__intro');
  if (!configEl || !intro) return;

  let config;
  try {
    config = JSON.parse(configEl.textContent);
  } catch (e) {
    return;
  }

  const headings = document.querySelectorAll('.vs-blog-article__content h2');
  const faqItems = document.querySelectorAll('.vs-faq__item');
  const faqHeadingEl = document.querySelector('.vs-faq__heading');

  if (!headings.length && !faqItems.length) return;

  const usedSlugs = {};

  function slugify(text) {
    let base = text
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-');
    let slug = base;
    let counter = 2;
    while (usedSlugs[slug]) {
      slug = base + '-' + counter;
      counter++;
    }
    usedSlugs[slug] = true;
    return slug;
  }

  const scrollOffsetCalc = 'calc(var(--sticky-header-desktop-height, 0px) + var(--sticky-header-mobile-height, 0px) + ' + config.scrollOffset + 'px)';
  const listItemsHTML = [];

  // Regular content sections (H2s) — each gets its own top-level number
  headings.forEach(function (heading) {
    if (!heading.id) {
      heading.id = slugify(heading.textContent);
    }
    heading.style.scrollMarginTop = scrollOffsetCalc;
    listItemsHTML.push('<li><a href="#' + heading.id + '">' + heading.textContent + '</a></li>');
  });

  // FAQ section — counted as ONE numbered topic; individual questions nest
  // underneath it, indented, not part of the main numbering sequence.
  // Reads existing "vs-faq__item" / "vs-faq__question" / "faq-heading"
  // markup already present on every post — no post needs editing.
  if (faqItems.length) {
    const faqTopicLabel = faqHeadingEl ? faqHeadingEl.textContent : 'Frequently Asked Questions';
    const faqTopicId = (faqHeadingEl && faqHeadingEl.id) ? faqHeadingEl.id : 'faq-heading';

    const subItemsHTML = [];

    faqItems.forEach(function (item) {
      const questionEl = item.querySelector('.vs-faq__question');
      if (!questionEl) return;

      if (!item.id) {
        item.id = slugify(questionEl.textContent);
      }
      item.style.scrollMarginTop = scrollOffsetCalc;
      subItemsHTML.push('<li><a href="#' + item.id + '" data-toc-faq-link>' + questionEl.textContent + '</a></li>');
    });

    listItemsHTML.push(
      '<li>' +
        '<a href="#' + faqTopicId + '">' + faqTopicLabel + '</a>' +
        '<ul class="vs-toc__sublist">' + subItemsHTML.join('') + '</ul>' +
      '</li>'
    );
  }

  const triggerHTML =
    '<button type="button" class="vs-toc-trigger" aria-haspopup="dialog" data-toc-open>' +
      '<span class="vs-toc-trigger__icon" aria-hidden="true">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="14" y2="18"/></svg>' +
      '</span>' +
      '<span>' + config.heading + '</span>' +
    '</button>';

  const dialogHTML =
    '<dialog class="vs-toc-dialog" data-toc-dialog>' +
      '<div class="vs-toc-dialog__inner">' +
        '<div class="vs-toc-dialog__header">' +
          '<span class="vs-toc-dialog__heading">' + config.heading + '</span>' +
          '<button type="button" class="vs-toc-dialog__close" data-toc-close aria-label="Close">&times;</button>' +
        '</div>' +
        '<div class="vs-toc-dialog__body">' +
          '<ol class="vs-toc__list">' + listItemsHTML.join('') + '</ol>' +
        '</div>' +
      '</div>' +
    '</dialog>';

  intro.insertAdjacentHTML('afterend', triggerHTML + dialogHTML);

  const triggerEl = document.querySelector('[data-toc-open]');
  const dialogEl = document.querySelector('[data-toc-dialog]');
  const closeEl = dialogEl.querySelector('[data-toc-close]');

  triggerEl.addEventListener('click', function () {
    dialogEl.showModal();
  });

  closeEl.addEventListener('click', function () {
    dialogEl.close();
  });

  dialogEl.addEventListener('click', function (e) {
    if (e.target === dialogEl) {
      dialogEl.close();
    }
  });

  dialogEl.querySelectorAll('a').forEach(function (link) {
    link.addEventListener('click', function () {
      if (link.hasAttribute('data-toc-faq-link')) {
        const targetId = link.getAttribute('href').slice(1);
        const targetEl = document.getElementById(targetId);
        if (targetEl && targetEl.tagName === 'DETAILS') {
          targetEl.open = true;
        }
      }
      dialogEl.close();
    });
  });
});